import { capitalize } from 'utils/helpers';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import services from 'services/endpoints';
import useAlert from 'utils/alert';

const useUnsuscribe = () => {
  const { t } = useTranslation();
  const { token } = useParams<any>();
  const [showFinalScreen, setShowfinalScreen] = useState(false);
  const showAlert = useAlert();
  const { mutate: unsuscribe, ...unsuscribeResponse } = useMutation(services.unsuscribe, {
    onSuccess: onUnsubscribed,
    onError: onUnsubscribeError,
  });

  function onUnsubscribed() {
    unsuscribeResponse.reset();
    showAlert(capitalize(t('dialogs:order-updated')), 'success');
    setShowfinalScreen(true);
  }

  function onUnsubscribeError() {
    unsuscribeResponse.reset();
  }

  const tokenResponse = useQuery(['tokenValidate', token], () => services.validateToken(token), {
    refetchOnWindowFocus: false,
    enabled: !!token,
  });

  return {
    t,
    tokenResponse,
    unsuscribeResponse,
    unsuscribe,
    showFinalScreen,
    setShowfinalScreen,
  };
};

export default useUnsuscribe;
